import { render, staticRenderFns } from "./default-component-item.vue?vue&type=template&id=4acdc880"
import script from "./default-component-item.vue?vue&type=script&lang=ts"
export * from "./default-component-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports